import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import { route } from '@helpers'
import React from 'react'

export default function SalonUnavailableFuture() {
    return (
        <EmphasizedContent>
            <Grid gap="20px">
                <Grid gap="10px">
                    <h3>The salon hasn't started yet.</h3>
                    <p>Please, return when the salon's open for entry.</p>
                </Grid>
            </Grid>
        </EmphasizedContent>
    )
}